import * as React from 'react'
import { getDayOfWeekShortName } from 'app/common/dateHelper'

export type CalendarHeaderItemProps = {
  dayOfWeek: number
  height: number
  width: number
  translate: (text: any) => any
}

export const CalendarHeaderItem: React.FC<CalendarHeaderItemProps> = ({
  dayOfWeek,
  height,
  width,
  translate,
}) => {
  const isWeekend = dayOfWeek === 5 || dayOfWeek === 6
  return (
    <div
      className={`tw-bp tw-flex tw-items-center tw-justify-start tw-pl-0.5 ${
        isWeekend ? 'tw-bg-content-primary' : 'tw-bg-base-100'
      }`}
      style={{
        width,
        height,
      }}
    >
      <span
        className={`tw-text-xs ${dayOfWeek === 6 ? 'tw-text-red-500' : 'tw-text-content-base'}`}
      >
        {translate(getDayOfWeekShortName(dayOfWeek + 1))}
      </span>
    </div>
  )
}
